import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'txTime'
})
export class TxTimePipe implements PipeTransform {

  private padRight(value: any, size: any, char: any) { return value + Array(size - value.length + 1).join(char || " ") }
  private padLeft(value: any, size: any, char: any) { return Array(size - value.length + 1).join(char || " ") + value }

  transform(value: any, ...args: any[]): any {

    if (value != null && typeof value != "undefined") {
      let sTime = value.toString();
      if (value != 0) {
        if (sTime.length == 5) {
          sTime = this.padLeft(sTime, 6, '0');
          sTime = this.padRight(sTime, 9, '0');
        }
        if (sTime.length == 8)
          sTime = this.padLeft(sTime, 9, '0');
        else if (sTime.length == 11) {
          sTime = sTime.substring(0, 8);
          sTime = this.padLeft(sTime, 9, '0');
        }
        else if (sTime.length == 6)
          sTime = this.padRight(sTime, 9, '0');
        else if (sTime.length >= 9)
          sTime = sTime.substring(0, 9);

        return sTime[0] + sTime[1] + ":" + sTime[2] + sTime[3] + ":" + sTime[4] + sTime[5];
      } else {
        return " ";
      }
    } else {
      return " ";
    }
  }

  dateConversion(dateStr) {
      if (dateStr != undefined && dateStr != null && dateStr != "" && dateStr != "0") {
          return dateStr.slice(6, 8).concat("/").concat(dateStr.slice(4, 6)).concat("/").concat(dateStr.slice(0, 4));
      } else {
          return "";
      }
  }
  dateConversion2(dateStr) {
    if (dateStr != undefined && dateStr != null && dateStr != "" && dateStr != "0") {
      var dd = dateStr.slice(8, 10);
      return dateStr.slice(5, 7).concat("/").concat(parseInt(dd)+1).concat("/").concat(dateStr.slice(0, 4));
        } else {
        return "";
    }
}


}
